<template>
  <div id="productTrackerContactsInfoPopup" class="modal fade" role="dialog">
    <div class="modal-dialog info-popup">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <span
            >Project Contacts
            <span v-if="!listType">
              <img
                src="/static/images/icons/chevron_right.svg"
                class="chevorn-right-img ml-5 mt-2"
                alt="chevron-right-icon"
              />
              Modify Contacts</span
            >
          </span>
          <img
            class="close-icon cursor-pointer"
            alt="close-icon"
            src="/static/images/icons/close_icon.svg"
            @click="closePopup"
          />
        </div>
        <div class="modal-body generic-body">
          <template v-if="listType">
            <div class="row pt-15 pb-20">
              <div class="col-xs-12 col-sm-8 modal-status-header pr-20">
                The followings contacts from your team will receive updates on the status for this
                product family.
              </div>
              <div class="col-xs-12 col-sm-4 xs-mt-10">
                <button
                  type="button"
                  class="btn btn-block emergo-white-button"
                  @click="getTeamMembers()"
                >
                  Modify Contacts
                </button>
              </div>
            </div>
            <div class="info-table">
              <table class="table status-table">
                <thead>
                  <tr :class="{ 'custom-padding': !checkRolePermissions }">
                    <template v-for="(header, index) in infoheaders">
                      <th :key="index">
                        {{ header.name }}
                        <span
                          class="sort pl-8"
                          @click="sortBy(header.key)"
                          :class="sortOrders[header.key] > 0 ? 'asc' : 'desc'"
                          v-if="header.key !== 'directives' && header.key !== 'trade_name'"
                          ><img src="/static/images/icons/sortDesc.svg"
                        /></span></th
                    ></template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in contactsData" :key="index">
                    <template v-for="(header, headerindex) in infoheaders">
                      <td :key="headerindex">
                        <span v-if="header.key === 'modified_on'"
                          >{{ data.audit_flag }} {{ data[header.key] | infoDate }}</span
                        >
                        <span v-else-if="header.key === 'contact'">
                          {{ data[header.key].name || '-' }}
                        </span>
                        <span v-else>{{ data[header.key] || '-' }}</span>
                      </td></template
                    >
                  </tr>
                  <tr v-if="!contactsData.length">
                    <td colspan="100%" class="center">No Contacts</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <template v-else>
            <div class="modal-status-header pt-15 pb-20">
              Please note that changes made here only apply to this product family for
              <span class="fw-500">{{ countryName }}</span
              >. For changes in other markets, please switch to the appropriate country tab.
            </div>
            <div class="custom-height">
              <div class="row pt-5">
                <div class="form-group col-xs-12 mb-10">
                  Select Project Contacts<span class="required-astreisk">*</span>
                </div>
                <div class="col-xs-12">
                  <multiselect
                    :showLabels="false"
                    :close-on-select="false"
                    class="multiselect-single-dropdown multiselect-multiple"
                    :class="!selectedContacts.length ? 'un-selected' : ''"
                    placeholder="Select Contacts"
                    label="first_name"
                    track-by="id"
                    :multiple="true"
                    :searchable="true"
                    :clear-on-select="false"
                    :options="usersList"
                    :value="selectedContacts"
                  >
                    <div class="selection-count" slot="selection" slot-scope="{ values, isOpen }">
                      <template v-if="!isOpen">
                        <img
                          src="/static/images/icons/filter.svg"
                          alt="filter-icon"
                          class="image-size"
                        /><span class="selected-count">{{ values.length }} Selected</span>
                      </template>
                      <template v-else-if="isOpen">
                        <img
                          src="/static/images/icons/filter.svg"
                          alt="filter-icon"
                          class="image-size"
                        />
                      </template>
                    </div>
                    <span slot="option" slot-scope="props">
                      <div
                        class="d-flex"
                        @input="selectContact(props.option.user_id, disableContactNum)"
                      >
                        <span class="checkbox inline-checkbox">
                          <label>
                            <input
                              type="checkbox"
                              :value="props.option"
                              :checked="selectedContacts.includes(props.option.user_id)"
                            />
                            <span
                              class="cr"
                              :class="{
                                'disabled-checkbox':
                                  disableContactNum && selectedContacts.length == disableContactNum
                              }"
                            >
                            </span>
                          </label>
                        </span>
                        <div
                          class="text-capitalize"
                          :class="{
                            'font-bold': selectedContacts.includes(props.option.user_id),
                            'font-wt-400': !selectedContacts.includes(props.option.id),
                            'disabled-text':
                              disableContactNum &&
                              !selectedContacts.includes(props.option.user_id) &&
                              selectedContacts.length === disableContactNum
                          }"
                          @click="selectContact(props.option.user_id, disableContactNum)"
                        >
                          {{ props.option.first_name }}
                          {{ props.option.last_name }}
                        </div>
                      </div>
                    </span>
                    <span slot="noResult">No matching data</span>
                  </multiselect>
                </div>
              </div>
              <div v-if="selectedContacts.length" class="row mt-20 col-xs-12">
                <span
                  class="selected-names text-capitalize mr-10 mb-20"
                  v-for="each in selectedContacts"
                  :key="each"
                >
                  {{ getContact(each).first_name }}
                  {{ getContact(each).last_name }}
                  <img
                    src="/static/images/icons/close_blue_icon.svg"
                    class="ml-10 cursor-pointer"
                    @click="selectContact(each, disableContactNum)"
                  />
                </span>
              </div>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <template v-if="!listType">
            <div class="col-xs-4 col-sm-3 p-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                @click="listType = true"
              >
                Back
              </button>
            </div>
            <div class="col-xs-4 col-sm-3 col-sm-offset-3 p-0 align-right">
              <button type="button" class="btn btn-block emergo-white-button" @click="closePopup">
                Cancel
              </button>
            </div>
            <div class="col-xs-4 col-sm-3 p-0">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                :disabled="isUpdateDisable"
                @click="updateContacts()"
              >
                Update
              </button>
            </div>
          </template>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import $ from 'jquery';
import { xor } from 'lodash';
import Loader from '../../UIComponents/Loader.vue';
import { getTeamMembers } from '../../../apis/team';
import { getUserData } from '../../../apis/profile';
import {
  updateProductTrackerContactsById,
  getProductTrackerContactsInfoById
} from '../../../apis/productTracker';

export default {
  components: {
    Loader
  },
  props: ['checkRolePermissions', 'selectedSingleProduct', 'usersListData', 'countries'],
  data() {
    return {
      disableContactNum: 0,
      contactsData: [],
      loaderStatus: false,
      infoheaders: [
        {
          name: 'Modified on',
          key: 'modified_on'
        },
        {
          name: 'Project Contact(s)',
          key: 'contact'
        }
      ],
      listType: true,
      usersList: [],
      selectedContacts: [],
      previousContacts: [],
      sortOrders: {}
    };
  },
  mounted() {
    $('#productTrackerContactsInfoPopup').on('shown.bs.modal', () => {
      this.listType = true;
      this.getProductTrackerContactsInfoById();
    });
  },
  filters: {
    infoDate(date) {
      if (!date) return '';
      return moment(date).format('Do MMM YYYY');
    }
  },
  computed: {
    isUpdateDisable() {
      if (this.selectedContacts.length) {
        if (this.previousContacts.length) {
          return !xor(this.previousContacts, this.selectedContacts).length;
        }
        return false;
      }
      return true;
    },
    countryName() {
      if (this.countries.length && this.selectedSingleProduct) {
        return (
          this.countries.find((e) => e.country_id === this.selectedSingleProduct.country_id)
            ?.name || ''
        );
      }
      return '';
    }
  },
  methods: {
    async getTeamMembers() {
      this.previousContacts = this.contactsData.filter((e) => e.active).map((e) => e.contact.id);
      this.selectedContacts = [...this.previousContacts];
      this.listType = false;
      if (!this.usersListData.length) {
        this.loaderStatus = true;
        const userData = JSON.parse(localStorage.getItem('userData')) || (await getUserData());
        const usersList = await getTeamMembers(
          userData.account_type_id === 2 || userData.account_type_id === 4 ? 1 : 0
        );
        this.usersList = usersList.filter(
          (user) => (user.role_id === 9 || user.role_id === 8) && !user.is_restricted
        );
        this.loaderStatus = false;
      } else this.usersList = this.usersListData;
    },
    selectContact(item, limit = 0) {
      if (this.selectedContacts.findIndex((c) => item === c) === -1) {
        this.selectedContacts.push(item);
        if (limit && this.selectedContacts.length > limit) {
          this.$nextTick(() => {
            this.selectedContacts.splice(limit, this.selectedContacts.length);
          });
        }
      } else {
        this.selectedContacts = this.selectedContacts.filter((c) => item !== c);
      }
    },
    getContact(id) {
      return this.usersList.find((f) => f.user_id === id) || {};
    },
    async updateContacts() {
      const response = await updateProductTrackerContactsById(
        this.selectedSingleProduct.id,
        this.selectedSingleProduct.country_id,
        {
          contact_ids: this.selectedContacts
        }
      );
      if (response.status_code === 200 && response.message === 'success') {
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Project contacts updated successfully.',
          group: 'custom-notification'
        });
        this.listType = true;
        this.getProductTrackerContactsInfoById();
      } else {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to update project contacts.',
          group: 'custom-notification'
        });
      }
    },
    closePopup() {
      this.contactsData = [];
      this.selectedContacts = [];
      this.listType = true;
      $('#productTrackerContactsInfoPopup').modal('hide');
      this.$emit('close');
    },
    async getProductTrackerContactsInfoById() {
      this.loaderStatus = true;
      this.contactsData = await getProductTrackerContactsInfoById(
        this.selectedSingleProduct.id,
        this.selectedSingleProduct.country_id
      );
      this.loaderStatus = false;
    },
    sortBy(field) {
      this.sortOrders[field] = !this.sortOrders[field];
      this.contactsData.sort((item1, item2) => {
        let x;
        let y;
        if (field === 'contact') {
          x = item1[field].name ? item1[field].name.toLowerCase() : '';
          y = item2[field].name ? item2[field].name.toLowerCase() : '';
        } else {
          x = item1[field] ? item1[field].toLowerCase() : '';
          y = item2[field] ? item2[field].toLowerCase() : '';
        }
        if (x < y) {
          return this.sortOrders[field] ? -1 : 1;
        }
        if (x > y) {
          return this.sortOrders[field] ? 1 : -1;
        }
        return 0;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-content {
  border-radius: $radius10;
}
.modal-header {
  padding: 25px 25px 0;
  background: $white;
  border-radius: $radius10;
  border: none;
  font-family: $font-family-roboto;
  font-weight: $font-weight-400;
  font-size: 24px;
  line-height: 28px;
  color: $primary;
}
.modal-status-header {
  font-family: $font-family-roboto;
  font-weight: $font-weight-400;
  font-size: $font-18;
  line-height: 21px;
  color: $dark-black-alpha;
}
.modal-body {
  padding: 15px 32px;
}
.modal-footer {
  background: $white;
  border-radius: $radius10;
  border: none;
  padding: 10px 32px 30px;
  text-align: left;
  div:not(:last-child) {
    padding-right: 15px;
  }
}
.close-icon {
  position: absolute;
  top: 18px;
  right: 18px;
}
.info-popup {
  .info-table {
    min-height: 280px;
    max-height: 280px;
    overflow-y: auto;
  }
  width: 615px;
}
.status-table {
  tbody {
    tr {
      td {
        font-size: $font-16;
        border-bottom: 1px solid $gray74;
        color: $shuttle-grey;
        padding: 16px 10px !important;
      }
      &:last-child {
        td {
          border-bottom: none;
        }
      }
    }
  }
  thead {
    tr {
      th {
        font-weight: 500;
        font-size: $font-14;
        color: $primary;
        padding: 16px 10px !important;
        border-bottom: 1px dashed $gray74 !important;
      }
    }
    background: $white;
    border-top: 1px solid $gray74;
  }
}

.sort {
  &.asc {
    img {
      -ms-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -webkit-transform: rotate(180deg);
      transform: rotate(180deg);
    }
  }
}
.input-label {
  font-family: $font-family-roboto;
  font-weight: $font-weight-400;
  font-size: $font-18;
  line-height: 21px;
  color: $dark-black-alpha;
}
.required-astreisk {
  color: $deep-thick-danger;
  margin-left: 5px;
}
.selected-names {
  background: $light-custom-blue-alpha;
  border-radius: $radius28;
  padding: 8px 15px 8px 17px;
  font-family: $font-family-roboto;
  font-weight: $font-weight-400;
  font-size: $font-16;
  line-height: 19px;
  color: $primary;
  display: inline-block;
}
.custom-height {
  min-height: 243px;
  border-bottom: 1px solid $gray74;
}
.chevorn-right-img {
  height: 28px;
  width: 30px;
  vertical-align: top;
}
@media screen and (max-width: 767px) {
  .info-popup {
    min-width: auto;
    .info-table {
      overflow-x: scroll;
      max-width: 100%;
    }
    .status-table {
      width: 400px;
      max-width: unset;
    }
  }
  .info-popup.modal-dialog {
    max-width: 90%;
  }
  .xs-mt-10 {
    margin-top: 10px;
  }
  .modal-footer {
    div:not(:last-child) {
      padding-right: 10px;
    }
  }
}
</style>
